module.exports = __webpack_public_path__ + "static/media/footer2.cdb9a18b.png";